import { styled } from 'buttered';

export let Subtitle = styled('h2')`
  font-size: 1.7em;
  font-weight: 600;
`;
